/* Yatas Bedding NL - collection filtering.
 *
 * Reproduces the reference's behaviour, which Shopify cannot give us directly:
 *   - multi-select within a facet is OR   (two sizes -> union)
 *   - across facets it is AND             (size AND hardness)
 *   - counts next to each value update as other facets are applied
 *   - price is chosen from pre-set bands, not a min/max box
 *
 * Storefront filters can only be configured in the Search & Discovery app,
 * which has no Admin API, and Shopify's own tag URLs are AND-only - so the
 * facet values live on products as "Facet: Value" tags and the whole collection
 * is pulled once from the ?view=data feed and filtered in memory.
 */
(function () {
  'use strict';

  var PAGE_SIZE = 24;

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function YbnFilters(root) {
    this.root = root;
    this.grid = root.querySelector('[data-filter-grid]');
    this.countEl = document.querySelector('[data-result-count]');
    this.moreBtn = root.querySelector('[data-filter-more]');
    this.clearBtn = root.querySelector('[data-filter-clear]');
    this.dataUrl = root.dataset.dataUrl;
    this.products = null;
    this.shown = PAGE_SIZE;
    this.loading = false;
    this.init();
  }

  YbnFilters.prototype.init = function () {
    var self = this;

    this.inputs = Array.prototype.slice.call(
      this.root.querySelectorAll('[data-facet-input]')
    );
    this.priceInputs = Array.prototype.slice.call(
      this.root.querySelectorAll('[data-price-band]')
    );
    this.stockInput = this.root.querySelector('[data-stock-input]');

    var all = this.inputs.concat(this.priceInputs);
    if (this.stockInput) all.push(this.stockInput);

    all.forEach(function (input) {
      input.addEventListener('change', function () {
        self.ensureData().then(function () {
          self.shown = PAGE_SIZE;
          self.apply();
        });
      });
    });

    if (this.moreBtn) {
      this.moreBtn.addEventListener('click', function (e) {
        if (!self.products) return; // no data yet: let the link behave normally
        e.preventDefault();
        self.shown += PAGE_SIZE;
        self.apply();
      });
    }

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', function (e) {
        if (!self.products) return;
        e.preventDefault();
        all.forEach(function (i) { i.checked = false; });
        self.shown = PAGE_SIZE;
        self.apply();
      });
    }

    this.wireDrawer();
    this.wireCompare();
    this.wireSort();
    this.restoreFromUrl(all);
  };

  /* ------------------------------------------------------------- drawer */
  /* The drawer mirrors the pills rather than duplicating their value lists,
   * so the two can never drift apart. Each facet becomes a +/- accordion and
   * its rows proxy clicks straight to the original checkbox. */
  YbnFilters.prototype.wireDrawer = function () {
    var self = this;
    var drawer = this.root.querySelector('[data-filters-drawer]');
    var opener = this.root.querySelector('[data-open-filters]');
    if (!drawer || !opener) return;

    var body = drawer.querySelector('[data-drawer-body]');

    function build() {
      body.innerHTML = '';

      var stock = self.root.querySelector('[data-stock-input]');
      if (stock) {
        var lab = document.createElement('label');
        lab.className = 'ybn-pill ybn-pill--check';
        var box = document.createElement('input');
        box.type = 'checkbox';
        box.checked = stock.checked;
        box.addEventListener('change', function () {
          stock.checked = box.checked;
          stock.dispatchEvent(new Event('change', { bubbles: true }));
        });
        lab.appendChild(box);
        lab.appendChild(Object.assign(document.createElement('span'), { textContent: 'Alleen op voorraad' }));
        body.appendChild(lab);
      }

      self.root.querySelectorAll('.ybn-filterbar__pills [data-facet]').forEach(function (pill) {
        var facet = pill.dataset.facet;
        var title = facet === '__price' ? 'Prijs' : facet;

        var acc = document.createElement('div');
        acc.className = 'ybn-acc';

        var head = document.createElement('button');
        head.type = 'button';
        head.className = 'ybn-acc__head';
        head.innerHTML = '<span>' + esc(title) + '</span><span class="ybn-acc__sign"></span>';

        var panel = document.createElement('div');
        panel.className = 'ybn-acc__body';
        panel.hidden = true;

        var list = document.createElement('ul');
        list.className = 'ybn-pill__values';

        pill.querySelectorAll('input').forEach(function (src) {
          var row = document.createElement('li');
          var label = document.createElement('label');
          label.className = 'ybn-pill__value';

          var box = document.createElement('input');
          box.type = 'checkbox';
          box.checked = src.checked;
          box.disabled = src.disabled;
          box.addEventListener('change', function () {
            src.checked = box.checked;
            src.dispatchEvent(new Event('change', { bubbles: true }));
          });

          var text = src.closest('label').querySelector('span');
          var count = src.closest('label').querySelector('[data-value-count]');

          label.appendChild(box);
          label.appendChild(Object.assign(document.createElement('span'), {
            textContent: text ? text.textContent : src.value
          }));
          if (count && count.textContent) {
            label.appendChild(Object.assign(document.createElement('span'), {
              className: 'ybn-pill__valcount',
              textContent: count.textContent
            }));
          }
          row.appendChild(label);
          list.appendChild(row);
        });

        panel.appendChild(list);
        head.addEventListener('click', function () {
          var open = !panel.hidden;
          panel.hidden = open;
          acc.classList.toggle('is-open', !open);
        });

        acc.appendChild(head);
        acc.appendChild(panel);
        body.appendChild(acc);
      });
    }

    opener.addEventListener('click', function () {
      self.ensureData().then(function () {
        build();
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        drawer.hidden = true;
        document.body.style.overflow = '';
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) {
        drawer.hidden = true;
        document.body.style.overflow = '';
      }
    });
  };

  /* ------------------------------------------------------------ compare */
  /* Turning the switch on puts a "Vergelijken" checkbox on every card and
   * reveals the tray. Picking up to three products fills the slots; the button
   * then opens a side-by-side view built from the same feed data, so no extra
   * request is needed. */
  YbnFilters.prototype.wireCompare = function () {
    var self = this;
    var toggle = this.root.querySelector('[data-compare-toggle]');
    var bar = this.root.querySelector('[data-compare-bar]');
    if (!toggle || !bar) return;

    this.compare = [];
    var MAX = 3;

    var slots = bar.querySelector('[data-compare-slots]');
    var counter = bar.querySelector('[data-compare-count]');
    var goBtn = bar.querySelector('[data-compare-go]');

    function paint() {
      if (counter) {
        counter.textContent = 'Geselecteerde producten (' + self.compare.length + '/' + MAX + ')';
      }
      if (slots) {
        slots.innerHTML = '';
        for (var i = 0; i < MAX; i++) {
          var p = self.compare[i];
          var el = document.createElement('span');
          el.className = 'ybn-comparebar__slot';
          if (p) {
            el.innerHTML = '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '">' +
              '<button type="button" class="ybn-comparebar__drop" aria-label="Verwijderen">&times;</button>';
            (function (prod) {
              el.querySelector('.ybn-comparebar__drop').addEventListener('click', function () {
                self.compare = self.compare.filter(function (x) { return x.id !== prod.id; });
                syncBoxes();
                paint();
              });
            })(p);
          } else {
            el.textContent = '+';
          }
          slots.appendChild(el);
        }
      }
      if (goBtn) goBtn.disabled = self.compare.length < 2;
    }

    function syncBoxes() {
      self.root.querySelectorAll('[data-compare-box]').forEach(function (box) {
        var id = parseInt(box.dataset.compareBox, 10);
        box.checked = self.compare.some(function (p) { return p.id === id; });
      });
    }

    /* Cards are re-rendered on every filter change, so the checkbox is added
     * after each paint rather than once at start-up. */
    this.decorateCards = function () {
      if (!toggle.checked || !self.grid) return;
      self.grid.querySelectorAll('.ybn-card').forEach(function (card, i) {
        if (card.querySelector('[data-compare-box]')) return;
        var prod = self.lastRendered && self.lastRendered[i];
        if (!prod) return;

        var label = document.createElement('label');
        label.className = 'ybn-card__compare';
        label.innerHTML = '<input type="checkbox" data-compare-box="' + prod.id + '"><span>Vergelijken</span>';
        label.querySelector('input').addEventListener('change', function (e) {
          if (e.target.checked) {
            if (self.compare.length >= MAX) { e.target.checked = false; return; }
            self.compare.push(prod);
          } else {
            self.compare = self.compare.filter(function (x) { return x.id !== prod.id; });
          }
          paint();
        });
        card.appendChild(label);
      });
      syncBoxes();
    };

    toggle.addEventListener('change', function () {
      bar.hidden = !toggle.checked;
      document.body.classList.toggle('ybn-has-comparebar', toggle.checked);
      if (toggle.checked) {
        self.ensureData().then(function () {
          if (!self.lastRendered) self.apply();
          self.decorateCards();
        });
      } else {
        self.compare = [];
        self.root.querySelectorAll('.ybn-card__compare').forEach(function (n) { n.remove(); });
        paint();
      }
    });

    var clear = bar.querySelector('[data-compare-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        self.compare = [];
        syncBoxes();
        paint();
      });
    }

    if (goBtn) {
      goBtn.addEventListener('click', function () { self.openCompare(); });
    }

    paint();
  };

  /* Side-by-side view. Rows are only shown when at least one product has a
   * value, so a table of empty cells never appears. */
  YbnFilters.prototype.openCompare = function () {
    var items = this.compare;
    if (items.length < 2) return;

    var rows = [
      { label: 'Prijs', get: function (p) { return money(p.price); } },
      { label: 'Merk', get: function (p) { return p.brand || ''; } },
      { label: 'Hardheid', get: function (p) { return p.hardness || ''; } },
      { label: 'Beschikbaarheid', get: function (p) { return p.available ? 'Op voorraad' : 'Uitverkocht'; } },
      { label: 'Kenmerken', get: function (p) { return (p.usps || []).join('<br>'); } }
    ];

    var head = '<tr><th></th>' + items.map(function (p) {
      return '<th><a href="' + esc(p.url) + '">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') +
        '<span>' + esc(p.title) + '</span></a></th>';
    }).join('') + '</tr>';

    var body = rows.filter(function (r) {
      return items.some(function (p) { return r.get(p); });
    }).map(function (r) {
      return '<tr><th scope="row">' + r.label + '</th>' +
        items.map(function (p) { return '<td>' + (r.get(p) || '-') + '</td>'; }).join('') + '</tr>';
    }).join('');

    var modal = document.createElement('div');
    modal.className = 'ybn-comparemodal';
    modal.innerHTML =
      '<div class="ybn-comparemodal__scrim"></div>' +
      '<div class="ybn-comparemodal__panel" role="dialog" aria-modal="true" aria-label="Vergelijken">' +
        '<header class="ybn-comparemodal__head">' +
          '<h2>Producten vergelijken</h2>' +
          '<button type="button" class="ybn-comparemodal__close" aria-label="Sluiten">&times;</button>' +
        '</header>' +
        '<div class="ybn-comparemodal__body">' +
          '<table class="ybn-comparetable">' + head + body + '</table>' +
        '</div>' +
      '</div>';

    function close() {
      modal.remove();
      document.body.style.overflow = '';
    }
    modal.querySelector('.ybn-comparemodal__scrim').addEventListener('click', close);
    modal.querySelector('.ybn-comparemodal__close').addEventListener('click', close);

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
  };

  /* --------------------------------------------------------------- sort */
  /* Sorting is server-side, so choosing a value reloads with sort_by set. */
  YbnFilters.prototype.wireSort = function () {
    var pill = this.root.querySelector('[data-sort-pill]');
    if (!pill) return;
    pill.querySelectorAll('[data-sort-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', input.value);
        window.location.href = url.toString();
      });
    });
  };

  /* Fetch every page of the JSON feed once, then keep it in memory. */
  YbnFilters.prototype.ensureData = function () {
    var self = this;
    if (this.products) return Promise.resolve(this.products);
    if (this.loadingPromise) return this.loadingPromise;

    this.root.classList.add('is-loading');

    this.loadingPromise = fetch(this.dataUrl + '&page=1')
      .then(function (r) { return r.json(); })
      .then(function (first) {
        var pages = first.pages || 1;
        if (pages <= 1) return [first];
        var rest = [];
        for (var p = 2; p <= pages; p++) {
          rest.push(fetch(self.dataUrl + '&page=' + p).then(function (r) { return r.json(); }));
        }
        return Promise.all(rest).then(function (others) { return [first].concat(others); });
      })
      .then(function (chunks) {
        var out = [];
        chunks.forEach(function (c) { out = out.concat(c.products || []); });
        self.products = out;
        self.root.classList.remove('is-loading');
        return out;
      })
      .catch(function () {
        self.root.classList.remove('is-loading');
        self.products = [];
        return [];
      });

    return this.loadingPromise;
  };

  /* Selected values, grouped by facet. */
  YbnFilters.prototype.selection = function () {
    var sel = {};
    this.inputs.forEach(function (input) {
      if (!input.checked) return;
      var facet = input.closest('[data-facet]').dataset.facet;
      (sel[facet] = sel[facet] || []).push(input.value);
    });
    return sel;
  };

  YbnFilters.prototype.priceBands = function () {
    return this.priceInputs.filter(function (i) { return i.checked; }).map(function (i) {
      var parts = i.value.split('-');
      return { min: parseInt(parts[0], 10), max: parseInt(parts[1], 10) };
    });
  };

  /* AND across facets, OR within one. `skip` lets the count for a facet be
   * computed as if that facet were not applied - which is how the reference
   * keeps its own value counts meaningful. */
  YbnFilters.prototype.match = function (product, sel, bands, stockOnly, skip) {
    if (stockOnly && !product.available) return false;

    if (bands.length && skip !== '__price') {
      var ok = bands.some(function (b) {
        return product.price >= b.min && (b.max === 0 || product.price <= b.max);
      });
      if (!ok) return false;
    }

    for (var facet in sel) {
      if (facet === skip) continue;
      var wanted = sel[facet];
      if (!wanted.length) continue;
      var prefix = facet + ': ';
      var hit = product.tags.some(function (t) {
        return t.indexOf(prefix) === 0 && wanted.indexOf(t.slice(prefix.length).trim()) !== -1;
      });
      if (!hit) return false;
    }
    return true;
  };

  YbnFilters.prototype.apply = function () {
    var self = this;
    var sel = this.selection();
    var bands = this.priceBands();
    var stockOnly = this.stockInput ? this.stockInput.checked : false;

    var matched = this.products.filter(function (p) {
      return self.match(p, sel, bands, stockOnly, null);
    });

    this.renderCounts(sel, bands, stockOnly);
    this.renderGrid(matched);
    this.syncUrl(sel, bands, stockOnly);
  };

  YbnFilters.prototype.renderCounts = function (sel, bands, stockOnly) {
    var self = this;

    this.root.querySelectorAll('[data-facet]').forEach(function (pill) {
      var facet = pill.dataset.facet;
      var pool = self.products.filter(function (p) {
        return self.match(p, sel, bands, stockOnly, facet);
      });

      // Price bands are not tags, so they are counted separately - the loop
      // below only knows about [data-facet-value] rows and skipped them, which
      // is why the Prijs panel showed no counts at all.
      if (facet === '__price') {
        pill.querySelectorAll('[data-price-band]').forEach(function (box) {
          var parts = box.value.split('-');
          var min = parseInt(parts[0], 10);
          var max = parseInt(parts[1], 10);
          var n = pool.filter(function (p) {
            return p.price >= min && (max === 0 || p.price <= max);
          }).length;

          var row = box.closest('.ybn-pill__value');
          if (!row) return;
          var badge = row.querySelector('[data-value-count]');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'ybn-pill__valcount';
            badge.setAttribute('data-value-count', '');
            row.appendChild(badge);
          }
          badge.textContent = n ? '(' + n + ')' : '';
          row.classList.toggle('is-empty', n === 0);
          if (!box.checked) box.disabled = n === 0;
        });
      }

      pill.querySelectorAll('[data-facet-value]').forEach(function (label) {
        var value = label.dataset.facetValue;
        var prefix = facet + ': ';
        var n = pool.filter(function (p) {
          return p.tags.some(function (t) {
            return t.indexOf(prefix) === 0 && t.slice(prefix.length).trim() === value;
          });
        }).length;

        var badge = label.querySelector('[data-value-count]');
        if (badge) badge.textContent = n ? '(' + n + ')' : '';
        // A value that can no longer match anything is disabled, not hidden -
        // the reference keeps the row visible so the list does not jump.
        label.classList.toggle('is-empty', n === 0);
        var box = label.querySelector('[data-facet-input]');
        if (box && !box.checked) box.disabled = n === 0;
      });

      // Price bands are tracked separately from facet tags, so its own pill
      // would otherwise never light up or show a count.
      var chosen = facet === '__price' ? bands.length : (sel[facet] || []).length;
      var counter = pill.querySelector('[data-facet-count]');
      if (counter) {
        counter.textContent = chosen;
        counter.hidden = chosen === 0;
      }
      pill.classList.toggle('is-active', chosen > 0);
    });
  };

  YbnFilters.prototype.card = function (p) {
    var title = p.model && p.title.indexOf(p.model) === 0
      ? '<strong>' + esc(p.model) + '</strong> ' + esc(p.title.slice(p.model.length).trim())
      : esc(p.title);

    var usps = (p.usps || []).slice(0, 2).map(function (u) {
      return '<li>' + esc(u) + '</li>';
    }).join('');

    var dots = '';
    if (p.hardness) {
      for (var i = 1; i <= 4; i++) {
        dots += '<span class="ybn-card__dot' + (i <= p.hardnessLevel ? ' is-on' : '') + '"></span>';
      }
      dots = '<span class="ybn-card__hardness"><span class="ybn-card__hardness-label">' +
        esc(p.hardness) + '</span><span class="ybn-card__dots">' + dots + '</span></span>';
    }

    var compare = p.compare > p.price
      ? ' <s class="ybn-card__was">' + money(p.compare) + '</s>' : '';

    // Same image carousel as the Liquid-rendered card, so a filtered grid does
    // not silently drop back to a single still.
    var imgs = (p.images && p.images.length ? p.images : (p.image ? [p.image] : []));
    var slides = imgs.map(function (src, i) {
      return '<div class="ybn-card__slide"><img class="ybn-card__img" src="' + esc(src) +
        '" alt="' + (i === 0 ? esc(p.title) : '') + '" loading="lazy"></div>';
    }).join('');
    var multi = imgs.length > 1;
    var slices = multi ? '<span class="ybn-card__slices" aria-hidden="true">' +
      imgs.map(function (_, i) { return '<span data-card-slice="' + i + '"></span>'; }).join('') +
      '</span>' : '';
    var pager = multi ? '<div class="ybn-card__pager" data-card-pager>' +
      imgs.map(function (_, i) {
        return '<button class="ybn-card__bullet' + (i === 0 ? ' is-active' : '') +
          '" type="button" data-card-dot="' + i + '" aria-label="Afbeelding ' + (i + 1) + '"></button>';
      }).join('') + '</div>' : '';

    return '' +
      '<article class="ybn-card">' +
        '<div class="ybn-card__media-wrap"' + (multi ? ' data-card-gallery' : '') + '>' +
          '<a class="ybn-card__media" href="' + esc(p.url) + '">' +
            (slides ? '<div class="ybn-card__track" data-card-track>' + slides + '</div>' : '') +
            slices +
          '</a>' +
          pager +
        '</div>' +
        '<div class="ybn-card__body">' +
          '<h3 class="ybn-card__title"><a href="' + esc(p.url) + '">' + title + '</a></h3>' +
          '<div class="ybn-card__meta"><span class="ybn-card__size"></span>' + dots + '</div>' +
          (usps ? '<ul class="ybn-card__usps">' + usps + '</ul>' : '<ul class="ybn-card__usps"></ul>') +
          '<div class="ybn-card__foot">' +
            '<span class="ybn-card__price">' + money(p.price) + compare + '</span>' +
            '<span class="ybn-card__brand">' + esc(p.brand) + '</span>' +
          '</div>' +
        '</div>' +
      '</article>';
  };

  YbnFilters.prototype.renderGrid = function (matched) {
    if (!this.grid) return;
    var slice = matched.slice(0, this.shown);
    this.grid.innerHTML = slice.map(this.card, this).join('');
    // Kept so the compare checkboxes can be re-attached after every repaint.
    this.lastRendered = slice;
    if (this.decorateCards) this.decorateCards();

    // Freshly injected cards have no gallery behaviour until they are wired.
    document.dispatchEvent(
      new CustomEvent('ybn:grid-rendered', { detail: { grid: this.grid } })
    );

    if (this.countEl) {
      this.countEl.textContent = matched.length + ' ' + (this.countEl.dataset.label || 'producten');
    }
    if (this.moreBtn) {
      this.moreBtn.hidden = this.shown >= matched.length;
    }

    var progress = this.root.querySelector('[data-progress-bar]');
    if (progress) {
      var pct = matched.length ? Math.round((slice.length / matched.length) * 100) : 100;
      progress.style.width = pct + '%';
    }
    var seen = this.root.querySelector('[data-progress-text]');
    if (seen) {
      seen.textContent = 'U heeft ' + slice.length + ' van de ' + matched.length + ' producten bekeken.';
    }
  };

  /* Keep the URL shareable without reloading. */
  YbnFilters.prototype.syncUrl = function (sel, bands, stockOnly) {
    var url = new URL(window.location.href);
    Array.prototype.slice.call(url.searchParams.keys()).forEach(function (k) {
      if (k.indexOf('f.') === 0) url.searchParams.delete(k);
    });
    for (var facet in sel) {
      if (sel[facet].length) url.searchParams.set('f.' + facet, sel[facet].join('|'));
    }
    if (bands.length) {
      url.searchParams.set('f.__price', bands.map(function (b) { return b.min + '-' + b.max; }).join('|'));
    }
    if (stockOnly) { url.searchParams.set('f.__stock', '1'); }
    window.history.replaceState({}, '', url);
  };

  YbnFilters.prototype.restoreFromUrl = function (all) {
    var self = this;
    var params = new URL(window.location.href).searchParams;
    var any = false;

    params.forEach(function (value, key) {
      if (key.indexOf('f.') !== 0) return;
      any = true;
      var wanted = value.split('|');
      if (key === 'f.__stock') {
        if (self.stockInput) self.stockInput.checked = true;
        return;
      }
      if (key === 'f.__price') {
        self.priceInputs.forEach(function (i) {
          if (wanted.indexOf(i.value) !== -1) i.checked = true;
        });
        return;
      }
      var facet = key.slice(2);
      self.inputs.forEach(function (i) {
        var pill = i.closest('[data-facet]');
        if (pill && pill.dataset.facet === facet && wanted.indexOf(i.value) !== -1) i.checked = true;
      });
    });

    if (any) {
      this.ensureData().then(function () { self.apply(); });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-filter-root]').forEach(function (el) {
      new YbnFilters(el);
    });
  });
})();
